// const URL = {
//     development: {
//         API: 'http://questionnaire-server.testing1.svc.k8s.bjo.wdcloud.cc'
//     },
//     production: {
//         API: 'http://questionnaire-server.testing1.svc.k8s.bjo.wdcloud.cc'
//     }
// }
// export default URL[process.env.NODE_ENV]


const hostname = window.location.hostname
const port = window.location.port;
const isIP=/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
let API = `https://hrss-api.${hostname.split('.').splice(1).join('.')}`;
if(isIP.test(hostname) || hostname.includes('dev') || hostname.includes('localhost') || !!port || hostname.includes('k8s')){
  if(hostname.includes('fat')){
    API = `https://hrss-api.fat.wdeduc.com/`;
  } else if(hostname.includes('uat')){
    API = `https://hrss-api.uat.wdeduc.com/`;
  } else if(hostname.includes('testing3')){
    API = `https://hrss-api.testing3.wdeduc.com/`;
  } else {
    API = `https://hrss-api.testing3.wdeduc.com/`;
  }
}
window.APP_BASE_URL = API ;
export default {
  API
};